var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"app-container"},[_c(_vm.currentList,{tag:"component",attrs:{"orders":_vm.orders,"params":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }